import { BooleanAnswer } from "./BooleanAnswer";
import { NumberAnswer } from "./NumberAnswer";
import { SelectAnswer } from "./SelectAnswer";
import { TextAnswer } from "./TextAnswer";
import ListTable from "./ListTable";
import Providers from "../../../Providers";
import Injuries from "../../../Injuries";
import { Button } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

const RenderQuestion = (question, index) => {
  const { question: label, initial_data, module } = question;

  // ================================
  // Add as much "questions" as you need
  // ================================
  switch (module) {
    case "text":
      return (
        <TextAnswer key={index} label={label} value={initial_data?.[0] || ""} />
      );

    case "choice":
      return (
        <SelectAnswer
          key={index}
          label={label}
          options={["Email", "Phone", "Text"]}
          value={initial_data?.[0]}
        />
      );

    case "boolean":
      return (
        <BooleanAnswer
          key={index}
          label={label}
          value={initial_data === true || initial_data === "Yes"}
        />
      );

    case "int":
    case "decimal":
      return (
        <NumberAnswer key={index} label={label} value={initial_data?.[0]} />
      );

    case "client_injuries":
      return <Injuries label={label} data={initial_data} />;

    case "client_appointment":
      return (
        <ListTable
          data={initial_data}
          label={label}
          actionButton={
            <Button
              className="py-2 pl-8 pr-2 text-xs text-indigo-700 normal-case bg-white border-indigo-700 hover:border-indigo-700 w-52 rounded-3xl"
              variant="outlined"
              onClick={() => null}
            >
              Add Appointment
              <AddCircleOutline fontSize="small" className="ml-auto" />
            </Button>
          }
        />
      );

    case "client_referral":
      return <ListTable data={initial_data} label={label} />;

    case "client_providers":
      return <Providers data={initial_data} label={label} />;

    default:
      return null;
  }
};

export default RenderQuestion;
